const STORAGE_KEY = "trinity_first_touch_attribution";
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

const clamp = (value, maxLength) => String(value || "").slice(0, maxLength);

export function captureFirstTouchAttribution() {
  if (sessionStorage.getItem(STORAGE_KEY)) return;
  const params = new URLSearchParams(window.location.search);
  const attribution = Object.fromEntries(UTM_KEYS.map((key) => [key, clamp(params.get(key), 120)]));
  attribution.landing_url = clamp(window.location.href, 1000);
  attribution.referrer = clamp(document.referrer, 1000);
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(attribution));
}

export function getFirstTouchAttribution() {
  try {
    const stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "{}");
    return {
      ...Object.fromEntries(UTM_KEYS.map((key) => [key, clamp(stored[key], 120)])),
      landing_url: clamp(stored.landing_url, 1000),
      referrer: clamp(stored.referrer, 1000),
    };
  } catch {
    return Object.fromEntries([...UTM_KEYS, "landing_url", "referrer"].map((key) => [key, ""]));
  }
}